
(function(){
  'use strict';

  document.documentElement.classList.add('vanta-xi-ready');

  function initGallery(root){
    var track=root.querySelector('[data-vxi-track]');
    var slides=[].slice.call(root.querySelectorAll('[data-vxi-slide]'));
    var thumbs=[].slice.call(root.querySelectorAll('[data-vxi-thumb]'));
    var prev=root.querySelector('[data-vxi-prev]');
    var next=root.querySelector('[data-vxi-next]');
    if(!track || slides.length < 2) return;

    var index=0, startX=0, startY=0, dragging=false;

    function goTo(nextIndex){
      index=(nextIndex+slides.length)%slides.length;
      track.style.transform='translate3d(-'+(index*100)+'%,0,0)';
      thumbs.forEach(function(btn,i){
        var active=i===index;
        btn.classList.toggle('is-active',active);
        btn.setAttribute('aria-selected',active?'true':'false');
      });
    }

    if(prev) prev.addEventListener('click',function(){goTo(index-1)});
    if(next) next.addEventListener('click',function(){goTo(index+1)});
    thumbs.forEach(function(btn){btn.addEventListener('click',function(){goTo(Number(btn.dataset.index)||0)})});

    root.addEventListener('keydown',function(e){
      if(e.key==='ArrowLeft'){e.preventDefault();goTo(index-1)}
      if(e.key==='ArrowRight'){e.preventDefault();goTo(index+1)}
    });
    root.setAttribute('tabindex','0');

    track.addEventListener('touchstart',function(e){
      if(!e.changedTouches.length) return;
      startX=e.changedTouches[0].clientX;
      startY=e.changedTouches[0].clientY;
      dragging=true;
    },{passive:true});
    track.addEventListener('touchend',function(e){
      if(!dragging || !e.changedTouches.length) return;
      var dx=e.changedTouches[0].clientX-startX;
      var dy=e.changedTouches[0].clientY-startY;
      dragging=false;
      if(Math.abs(dx)>45 && Math.abs(dx)>Math.abs(dy)) goTo(index+(dx<0?1:-1));
    },{passive:true});

    goTo(0);
  }

  function initProduct(root){
    var variant=root.querySelector('[data-vxi-variant]');
    var price=root.querySelector('[data-vxi-price]');
    if(variant && variant.tagName==='SELECT' && price){
      variant.addEventListener('change',function(){
        var option=variant.options[variant.selectedIndex];
        if(option && option.dataset.price) price.textContent=option.dataset.price;
      });
    }
  }

  document.addEventListener('DOMContentLoaded',function(){
    document.querySelectorAll('[data-vxi-gallery]').forEach(initGallery);
    document.querySelectorAll('[data-vxi-product]').forEach(initProduct);
  });
})();
